import React from "react";
import { Navigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { authStore } from "../../stores/authStore.js";

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = observer(({ children }) => {
  if (!authStore.isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }
  return children;
});

export default ProtectedRoute;
